export default __webpack_public_path__ + "static/media/pic29.9594efc9.jpg";